import { Component, OnInit } from '@angular/core';
import {DataService} from '../../../../../../services/commande-client/data.service';

@Component({
  selector: 'app-valide-cmd-fourn',
  templateUrl: './valide-cmd-fourn.component.html',
  styleUrls: ['./valide-cmd-fourn.component.scss']
})
export class ValideCmdFournComponent implements OnInit {

    constructor(private dataService: DataService) {}

    ngOnInit(): void {
        this.dataService.filterOrdersByStatus('Valide');
    }

}
